const FormFilter = [
  {
    type: "multipleSelect",
    options: "CatBranch",
    label: "branch",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "Branch",
    id: "Branch",
    id2: "BranchName",
    datatype: "select",
    show: true,
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatCustomer",
    label: "organization_name",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "Customer",
    id2: "CustomerName",
    id: "Customer",
    datatype: "select",
    show: true,
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    values: [],
  },
  {
    type: "Datetime",
    label: "transaction_date",
    name: "transaction_date",
    class: "col-md-3 col-lg-3 col-sm-12",
    id: "InvoiceDate",
    id2: "InvoiceDate",
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    format: "YYYY-MM-DD",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatType",
    label: "transaction_type",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "Type",
    id: "Type",
    id2: "Type",
    datatype: "select",
    show: true,
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    values: [],
  },
  {
    type: "Datetime",
    label: "due_date",
    name: "due_date",
    class: "col-md-3 col-lg-3 col-sm-12",
    id: "DueDate",
    id2: "DueDate",
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    format: "YYYY-MM-DD",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatCurrency",
    label: "local_currency",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "Currency",
    id2: "Currency",
    id: "Currency",
    datatype: "select",
    show: true,
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    values: [],
  },
  {
    type: "multipleSelect",
    options: "CatTransportMode",
    label: "transport_mode",
    class: "col-md-3 col-lg-3 col-sm-12",
    name: "TransportMode",
    id2: "TransportMode",
    id: "TransportMode",
    datatype: "select",
    show: true,
    style: {fontSize: "11px", fontWeight: "bold"},
    value: "",
    values: [],
  },
  // {
  //   type: "multipleSelect",
  //   options: "CatStatus",
  //   label: "status",
  //   class: "col-md-3 col-lg-3 col-sm-12",
  //   name: "Status",
  //   id2: "Status",
  //   id: "Status",
  //   datatype: "select",
  //   show: true,
  //   style: {fontSize: "11px", fontWeight: "bold"},
  //   value: "",
  //   values: [],
  // },
];

export default FormFilter;
